<template>

    <b-card header-tag="header" class="m-3" no-body>
        <template #header>
            <header-sagres titulo="Contato dos responsáveis" breakpoint="xl">
                <template #customContent>

                    <div class="d-flex align-items-center">
                        <b-form-radio-group id="btn-radios-1" v-model="selected" :options="opcaoSelecionada"
                            name="radios-btn-default" buttons size="sm"></b-form-radio-group>
                    </div>

                </template>
            </header-sagres>
        </template>

        <!-- Itera sobre listaExercicio para renderizar os cards -->
        <div v-for="(items, index) in listaExercicio" :key="index" class="mb-4">
            <b-card>
                <template #header>
                    <h5 class="text-center font-weight-bold d-flex justify-content-center align-items-center my-2">
                        Exercício:
                        {{ exercicios[index] }}
                    </h5>
                </template>

                <!-- Tabela para os itens do exercício -->
                <b-table :items="items" :fields="fields" striped show-empty hover stacked="xl " :per-page="perPage"
                    :current-page="currentPages[index]">
                    <template #cell(actions)="row">
                        <b-link class="text-dark" @click="row.toggleDetails">
                            <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                        </b-link>
                    </template>


                    <template #row-details="row">
                        <CardContatoResponsavel :contato="row.item.ContatoUnidadeOrcamentaria" :IdUnidade="row.item.Id"
                            :campoAtivo="row.item.Exercicio === exercicios[0] ? true : false"
                            @dadosAtualizados="listarUnidadesOrcamentarias(selected)" />
                    </template>

                    <template #empty>
                        <span>Não foram encontrados resultados.</span>
                    </template>

                </b-table>
                <div class="d-flex justify-content-center">
                    <b-pagination v-model="currentPages[index]" :total-rows="items.length" :per-page="perPage"
                        aria-controls="my-table" size="sm"></b-pagination>
                </div>
            </b-card>
        </div>
    </b-card>

</template>

<script lang="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { UtilsTS } from '@/utilsts'

import { BotaoSagres } from "@/types/botao-sagres";
import unidadeOrcamentariaService from "@/services/entregas/uo/unidadeOrcamentariaService";
import { unidadeOrcamentaria } from "@/types/ug/uo/unidade-orcamentaria";
import CardContatoResponsavel from "@/components/entregas/uo/CardContatoResponsavel.vue";

import { TableField } from "@/types/table-field";
import { fieldsUO } from "@/types/ug/uo/fieldsUO";

const CompProps = Vue.extend({
    name: "ContatosResponsaveis",
    components: {
        HeaderSagres,
        CardContatoResponsavel,

    },
});


@Component
export default class ContatosResponsaveis extends mixins(UtilsTS, CompProps) {


    //Variável para filtrar o tempo
    selected = false

    //variável para o loading da tabela
    overlayCard = false

    // Array para armazenar arrays de unidadeOrcamentaria
    listaExercicio: unidadeOrcamentaria[][] = [];

    ano = -1
    exercicios: number[] = [];

    // lista para radio de filtro
    opcaoSelecionada = [
        { text: 'Todos', value: true },
        { text: 'Mais recente', value: false },
    ]

    //variáveis de paginação

    perPage = 10
    currentPage = 1
    currentPages: number[] = [];
    fields: TableField[] = [...fieldsUO]





    async mounted() {
        this.listarUnidadesOrcamentarias(this.selected)
    }

    //Essa função vai alimentar a tabela de dados por meio de um array de arrays do objeto unidadeOrcamentaria
    async listarUnidadesOrcamentarias(todos: boolean) {
        //zerando variáveis de referência
        this.ano = -1
        this.exercicios = []
        const novaLista: unidadeOrcamentaria[][] = [];
        try {
            store.blockScreen = true
            const response = await unidadeOrcamentariaService.listarUnidadesOrcamentarias(todos)
            //console.log(response)


            //Mapeia e separa os exercícios do retorno da api
            response.forEach((i: unidadeOrcamentaria) => {
                if ((i.Exercicio !== this.ano) && (!this.exercicios.includes(i.Exercicio))) {
                    this.ano = i.Exercicio
                    this.exercicios.push(this.ano)
                }
            })

            //Ordena os exercícios
            this.exercicios.sort((a, b) => b - a);

            //Ordena as unidades orçamentárias de acordo com o exercício
            response.forEach((uo: unidadeOrcamentaria) => {

                for (let i = 0; i < this.exercicios.length; i++) {
                    if (uo.Exercicio === this.exercicios[i]) {
                        if (!novaLista[i]) {
                            novaLista[i] = [];
                        }
                        novaLista[i].push(uo);

                    }
                }

            }

            )

            //atribui a novaLista ao array de arrays de unidadeOrcamentaria
            this.listaExercicio = novaLista;


            // Inicializa o array de páginas atuais
            this.currentPages = this.listaExercicio.map(() => 1);


        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }


    @Watch('selected')
    handleObjectChange(newV) {

        this.listarUnidadesOrcamentarias(newV)
        //console.log(newV)

    }

}   
</script>

<style></style>